var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 21,
    viewBox: "0 0 18 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8662 4.375H6.24121C5.77708 4.375 5.33196 4.55937 5.00377 4.88756C4.67559 5.21575 4.49121 5.66087 4.49121 6.125V18.375C4.49121 18.8391 4.67559 19.2842 5.00377 19.6124C5.33196 19.9406 5.77708 20.125 6.24121 20.125H15.8662C16.3303 20.125 16.7755 19.9406 17.1036 19.6124C17.4318 19.2842 17.6162 18.8391 17.6162 18.375V6.125C17.6162 5.66087 17.4318 5.21575 17.1036 4.88756C16.7755 4.55937 16.3303 4.375 15.8662 4.375ZM13.2412 0.875H2.74121C2.27708 0.875 1.83196 1.05937 1.50377 1.38756C1.17559 1.71575 0.991211 2.16087 0.991211 2.625V14.875H2.74121V2.625H13.2412V0.875Z",
    fill: "#A7A5A5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/CopyIcon.cf7fa4d7458eb507fc95cc147dda74b6.svg";
export { ForwardRef as ReactComponent };